import { render } from "./StatusLabel.vue?vue&type=template&id=0dcfe0ec"
import script from "./StatusLabel.vue?vue&type=script&lang=js"
export * from "./StatusLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__